module.exports = __webpack_public_path__ + "img/wheel_buyfeature_normal_bg.d6253abd.png";